import React, { useState } from "react";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { Accordion, Table, TableProps } from "../../../Common/UI/Index";
import { AccordionType } from "../../../Common/UI/Accordion/Types";
import { Capitalize } from "./Utilities";
import "./Style.scss";

interface BandingListProps {
  /**
   * Type of band
   */
  band: string;
  /**
   * Table data
   */
  data: TableProps;
}

/**
 * Responsible for viewing the banding list
 * @param props Type of band
 * @returns JSX element
 */
export const BandingListView: React.FC<BandingListProps> = (props: BandingListProps) => {
  const { band, data } = props;
  const { t: translate } = useTranslation();
  const bandTitle = (data.dataRow !== undefined) ?
    (`${Capitalize(band)}${" ("}${data.dataRow.length}${")"}`) :
    Capitalize(band);
  const [detailsAccordionOpen, setDetailsAccordionOpen] = useState<boolean>(false);

  /**
   * Callback function onclick of banding details accordion
   */
  const onBandingAccordionClick = (): void => {
    setDetailsAccordionOpen(!detailsAccordionOpen);
  };

  const accordionData: AccordionType[] = [
    {
      name: bandTitle,
      content: <div>
        <Table
          id="ebt-outputConfig-banding-table"
          tableData={data}
          emptyStateText={translate("OutputConfig.FinalOutputTable.NoEntries")}
        />
      </div>,
      className: "execution-details-container__execution-details-accordion",
      onAccordionClick: onBandingAccordionClick
    },
  ];
  return (
    <div className="ebt-banding-accordion">
      <Accordion
        data={accordionData}
        accordionId="banding"
        defaultOpenSection={0}
      />
    </div>
  );
};

